// Reverse map: stock location type -> packaging method type
export const STOCK_LOCATION_TYPE_TO_PACKAGING_METHOD = {
  POUCH_PACKAGER: "POUCH",
  ATC2_POUCH_PACKAGER: "POUCH",
  BLISTER_PACKAGER: "BLISTER_CARD",
  VIAL_FILLER: "VIAL",
};

// Forward map: packaging method -> stock location types
export const PACKAGING_METHOD_TO_STOCK_LOCATION_TYPES = {
  POUCH: ["POUCH_PACKAGER", "ATC2_POUCH_PACKAGER"],
  BLISTER_CARD: ["BLISTER_PACKAGER"],
  VIAL: ["VIAL_FILLER"],
};

// Packaging method -> dashboard view names
export const PACKAGING_METHOD_TO_DASHBOARD_VIEWS = {
  VIAL: ["TruScript"],
  BLISTER_CARD: ["TruCard"],
  POUCH: ["TruPak"],
};
